import React, { Component } from "react";
import _ from "lodash";

import DiscoverFilledIcon from "@atlaskit/icon/glyph/discover-filled";
import HomeCircleIcon from "@atlaskit/icon/glyph/home-circle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ListingContext } from "../../Context";

import { PrimaryColor } from "../../utils/consts";

import SkeletonText from "../../components/skeleton/SkeletonText";

export default class ListingProperties extends Component {
  render() {
    return (
      <ListingContext.Consumer>
        {listingContext => {
          const listing = listingContext.listing || {};
          const physicalProperties = listing.physicalProperties || {};
          const parking = listing.parking || {};
          if (listingContext.loading) {
            return (
              <div className="listing-properties">
                <SkeletonText lines={2} />
              </div>
            );
          } else if (!_.isEmpty(parking) || !_.isEmpty(physicalProperties)) {
            return (
              <div className="listing-properties">
                {physicalProperties.footage && (
                  <span className="listing-properties__property">
                    <HomeCircleIcon small="small" primaryColor={PrimaryColor} />
                    {`${physicalProperties.footage} sq ft`}
                  </span>
                )}
                {!!physicalProperties.beds && (
                  <span className="listing-properties__property">
                    <FontAwesomeIcon
                      className="listing-properties__icon"
                      color={PrimaryColor}
                      size="1x"
                      icon="bed"
                    />
                    <span className="listing-properties__property-amount">
                      {physicalProperties.beds}
                    </span>
                    {` beds`}
                  </span>
                )}
                {!!physicalProperties.baths && (
                  <span className="listing-properties__property">
                    <FontAwesomeIcon
                      className="listing-properties__icon"
                      color={PrimaryColor}
                      size="1x"
                      icon="bath"
                    />
                    <span className="listing-properties__property-amount">
                      {physicalProperties.baths}
                    </span>
                    {` baths`}
                  </span>
                )}
                {!!parking.parkingIncluded &&
                  !!parking.totalParking && (
                    <span className="listing-properties__property">
                      <FontAwesomeIcon
                        className="listing-properties__icon"
                        color={PrimaryColor}
                        size="1x"
                        icon="car"
                      />
                      <span className="listing-properties__property-amount">
                        {parking.totalParking}
                      </span>
                      {` parking`}
                    </span>
                  )}
                {physicalProperties.facingDirection && (
                  <span className="listing-properties__property">
                    <DiscoverFilledIcon
                      small="small"
                      primaryColor={PrimaryColor}
                    />
                    {`${physicalProperties.facingDirection} Facing`}
                  </span>
                )}
              </div>
            );
          } else {
            return null;
          }
        }}
      </ListingContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/listing/ListingProperties.js